import { render } from "./AuthLayout.vue?vue&type=template&id=78a5ddcd&scoped=true"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=78a5ddcd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a5ddcd"]])

export default __exports__